import stepperCss from './number-stepper.css?inline'

export function getStepperCss(): string {
  return stepperCss
}

function parseNum(value: string, fallback: number): number {
  if (value.trim() === '') return fallback
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

function clampToBounds(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

/** Wandelt `input[type=number][data-uzw-v2-stepper]` in Minus | Feld | Plus um (idempotent). */
export function enhanceNumberSteppers(root: ParentNode): void {
  const inputs = Array.from(root.querySelectorAll<HTMLInputElement>('input[type="number"][data-uzw-v2-stepper]'))
  for (const input of inputs) {
    if (input.dataset.uzwV2StepperReady === '1') continue
    input.dataset.uzwV2StepperReady = '1'

    const wrapper = document.createElement('div')
    wrapper.className = 'uzw-v2-stepper'
    input.parentElement?.insertBefore(wrapper, input)
    wrapper.appendChild(input)

    const minus = document.createElement('button')
    minus.type = 'button'
    minus.className = 'uzw-v2-stepper-btn'
    minus.setAttribute('aria-label', 'Wert verringern')
    minus.textContent = '−'

    const plus = document.createElement('button')
    plus.type = 'button'
    plus.className = 'uzw-v2-stepper-btn'
    plus.setAttribute('aria-label', 'Wert erhöhen')
    plus.textContent = '+'

    wrapper.insertBefore(minus, input)
    wrapper.appendChild(plus)

    const applyDelta = (delta: number) => {
      const step = parseNum(input.step, 1)
      const min = parseNum(input.min, Number.NEGATIVE_INFINITY)
      const max = parseNum(input.max, Number.POSITIVE_INFINITY)
      const current = parseNum(input.value, min !== Number.NEGATIVE_INFINITY ? min : 0)
      const next = clampToBounds(current + delta * step, min, max)
      input.value = String(Number.isInteger(next) ? Math.trunc(next) : next)
      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    }

    minus.addEventListener('click', () => applyDelta(-1))
    plus.addEventListener('click', () => applyDelta(1))
  }
}
